import cn from "@/v2-ui/utils/utils.cn"
import {
  REGISTRY_ITEM_CLASS,
  REGISTRY_PANE_CLASS,
  type RegistryGroup,
  type RegistryType,
} from "@/v2-backoffice-client/license/featureGroup/compose/registry/license.featureGroup.registry.utils"

export type LicenseFeatureGroupRegistryFamiliesPaneProps = {
  /** The type whose families are listed; none picked yet when null. */
  type: RegistryType | null
  families: readonly RegistryGroup[]
  selectedFamily: string | null
  onSelect(family: string | null): void
}

// The second column: the code families inside the chosen type, under an
// "All" row that is selected until a family narrows the features — the
// column-browser convention, so the third column always shows exactly what
// the selection says.
function LicenseFeatureGroupRegistryFamiliesPane(
  props: LicenseFeatureGroupRegistryFamiliesPaneProps,
) {
  const { type, families, selectedFamily, onSelect } = props

  if (!type) {
    return (
      <div className={REGISTRY_PANE_CLASS}>
        <p className="px-2.5 py-3 text-xs text-muted-foreground">
          Pick a type to see its code families.
        </p>
      </div>
    )
  }

  return (
    <div className={REGISTRY_PANE_CLASS}>
      <ul>
        <li>
          <button
            type="button"
            className={cn(
              REGISTRY_ITEM_CLASS,
              selectedFamily === null && "bg-muted font-medium",
            )}
            aria-pressed={selectedFamily === null}
            data-feature-code="UI_BackofficeFeatureGroup_Registry_FamilyAll"
            onClick={() => {
              onSelect(null)
            }}
          >
            <span className="min-w-0 flex-1 truncate">All</span>
            <span className="tabular-nums text-muted-foreground">
              {type.count}
            </span>
          </button>
        </li>
        {families.map((group) => (
          <li key={group.Family}>
            <button
              type="button"
              className={cn(
                REGISTRY_ITEM_CLASS,
                group.Family === selectedFamily && "bg-muted font-medium",
              )}
              aria-pressed={group.Family === selectedFamily}
              data-feature-code="UI_BackofficeFeatureGroup_Registry_Family"
              onClick={() => {
                onSelect(group.Family === selectedFamily ? null : group.Family)
              }}
            >
              <span className="min-w-0 flex-1 truncate font-mono text-[11px]">
                {group.Family}
              </span>
              <span className="tabular-nums text-muted-foreground">
                {group.FeatureCount}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LicenseFeatureGroupRegistryFamiliesPane
